import React from "react";
import {
  Grid,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";

const FormSolicitudOxigeno = (props) => {
  const {
    fechaIngreso = "",
  } = props.formValues;


  return (
    <React.Fragment>
      <Grid container justify='center' spacing={2}>
        <Grid item xs={12} md={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Inicio"
              name="fechaIngreso"
              value={
                fechaIngreso !== undefined && moment(fechaIngreso).isValid()
                  ? moment(fechaIngreso)
                  : null
              }
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("fechaIngreso", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              validators={[
                "required",
              ]}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default FormSolicitudOxigeno;
